import { QuillEditorConfig } from './../../../../../assets/data/quill-editor-config';
import { CRUDActionsEnum } from './../../../enum/crud-actions.enum';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrganizationTypesEnum } from './../../../enum/organization-types.enum';
import * as moment from 'moment';

@Component({
  selector: 'announcement-save',
  templateUrl: './save.component.html',
  styleUrls: ['./save.component.scss']
})
export class SaveComponent implements OnInit {

  constructor() { }

  @Input() announcement: any;
  @Input() loading: boolean;
  @Input() announcementType: string;

  @Output() onAnnouncementSave = new EventEmitter();

  public announcementText: string;
  public expiresIn: number;
  public crudActions = CRUDActionsEnum;
  public quillConfig = QuillEditorConfig.ANNOUNCEMENT.editorConfig;
  public editorStyle = QuillEditorConfig.ANNOUNCEMENT.editorStyle;
  public organizationTypes = OrganizationTypesEnum;
  public priority: number = 2;

  ngOnInit() {
    this.announcementText = (this.announcement) ? this.announcement.announcement : '';
    this.priority = (this.announcement) ? this.announcement.priority : 2;
    this._setExpirationField(this.announcement ? this.announcement.expirationDateTime: null);
  }

  public onSave() {
    this.onAnnouncementSave.emit({ expiresIn: this.expiresIn, announcemntText: this.announcementText });
  }

  /**
   * Fire events based on Cancel/Save button clicked
   * @param action
   */
  public onApplyActions(action: string): void {
    if (action === this.crudActions.CANCEL) {
      this.onAnnouncementSave.emit({ action: this.crudActions.CANCEL });
    } else if (action === this.crudActions.SAVE) {
      this.onAnnouncementSave.emit({ action: this.crudActions.SAVE, data: { expirationDateTime: this._getExpirationDate(), announcemntText: this.announcementText, priority: this.priority } });
    }
  }

  /**
   * Get expiration weeks with current date
   * expiration date - current date
   * if its greater than 7 days take 2 weeks otherwise 1
   * @param expirationDate
   */
  private _setExpirationField(expirationDate = null): void {
    if (!expirationDate) {
      this.expiresIn = 0;
    } else {
      const duration = moment(expirationDate).diff(moment());
      const days = moment.duration(duration).asDays();

      this.expiresIn = days > 7 ? 2 : 1;
    }
  }

  /**
   * Get Expiration day based on Weeks selected
   * 1 week ==> current day + 7 days
   * 2 week ==> current day + 14 days
   */
  private _getExpirationDate(): Date {
    if (!Number(this.expiresIn)) return null;

    const days = this.expiresIn * 7;
    return moment().add(days, 'days').toDate();
  }

  get popup() {
    return this.priority === 1;
  }

  set popup(val: boolean) {
    this.priority = val ? 1 : 2
  }
}
